export default "__VITE_ASSET__BBEh$ErZ__"